import React from "react";
import { Helmet } from "react-helmet-async";
import Navbar from "../Components/Navbar/Navbar";
import ProductCard from "../Components/ProductCard/ProductCard";
import Footer from "../Components/Footer/Footer";
import { Box } from "@mui/material";
import CardImg from "../Assets/vegan_apple_turnover.png";
import useMetaTracking from "../hooks/useMetaTracking";

function VeganAppleTurnover() {
  useMetaTracking("ViewContent", {
    content_name: "Vegan Apple Turnover",
    content_category: "Vegan Menu",
    content_ids: ["vegan_apple_turnover"],
    content_type: "vegan_vietnamese_pastries",
    value: 2.50,
    currency: "USD",
  });

  return (
    <>
      <Helmet>
        <title>Vegan Apple Turnover | Đông Hưng Viên Bakery</title>
        <meta
          name="description"
          content="Wrap yourself in cozy flavors with this vegan turnover filled with classic apple goodness. Delicate layers and a fragrant, fruity center—just right for satisfying that sweet tooth."
        />
        <meta
          property="og:title"
          content="Vegan Apple Turnover | Đông Hưng Viên Bakery"
        />
        <meta
          property="og:description"
          content="Wrap yourself in cozy flavors with this vegan turnover filled with classic apple goodness. Delicate layers and a fragrant, fruity center—just right for satisfying that sweet tooth."
        />
      </Helmet>
      <Box className="product-page" sx={{ pt: 10, background: "#0f0f0f" }}>
        <Navbar />
        <ProductCard
          cardImg={CardImg}
          titleHead="VEGAN APPLE TURNOVER"
          titleSubHead="$2.50 each"
          detailBody="Wrap yourself in cozy flavors with this vegan turnover filled with classic apple goodness. Delicate layers and a fragrant, fruity center—just right for satisfying that sweet tooth."
          detailBodyBr="Contains: wheat, soy, almond"
          detailBody3="Vegan"
          ProductCardBtn="View Full Vegan Menu"
          btnLink="/vegan-menu"
        />
        <Footer />
      </Box>
    </>
  );
}

export default VeganAppleTurnover;